import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';

export default function CheckoutPage() {
  const { user } = useAuth();
  const [mode, setMode] = useState('checkout');
  const [search, setSearch] = useState('');
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [sites, setSites] = useState([]);
  const [form, setForm] = useState({ site_id: '', due_at: '', quantity: 1, notes: '' });
  const [returnForm, setReturnForm] = useState({ condition_in: 'good', notes: '' });
  const [activeCheckouts, setActiveCheckouts] = useState([]);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/api/auth/me').then(r => setSites(r.data.sites || []));
    loadCheckouts();
  }, []);

  const loadCheckouts = () => {
    axios.get('/api/checkouts').then(r => setActiveCheckouts(r.data)).catch(()=>{});
  };

  const searchItems = () => {
    if (!search.trim()) return;
    axios.get('/api/inventory', { params: { search } }).then(r => setItems(r.data)).catch(()=>{});
  };

  const doCheckout = async () => {
    if (!selected || !form.due_at) { setError('Select an item and return date'); return; }
    try {
      await axios.post('/api/checkouts', { item_id: selected.id, site_id: form.site_id || null, due_at: form.due_at, quantity: form.quantity, notes: form.notes });
      setMsg(`${selected.name} checked out successfully`); setSelected(null); setSearch(''); setItems([]); setForm({ site_id:'', due_at:'', quantity:1, notes:'' }); setError('');
      loadCheckouts();
    } catch(e) { setError(e.response?.data?.error || 'Checkout failed'); }
  };

  const doReturn = async (checkoutId) => {
    try {
      await axios.patch(`/api/checkouts/${checkoutId}/return`, returnForm);
      setMsg('Item returned successfully'); loadCheckouts();
    } catch(e) { setError(e.response?.data?.error || 'Return failed'); }
  };

  return (
    <Layout>
      <div style={{marginBottom:'20px'}}>
        <h1 style={{fontSize:'20px',fontWeight:'700',color:'#0C447C',margin:0}}>Checkout & Return</h1>
      </div>
      <div style={{display:'flex',gap:'8px',marginBottom:'20px'}}>
        {['checkout','return'].map(m => (
          <button key={m} onClick={()=>{setMode(m);setMsg('');setError('');}} style={{padding:'9px 24px',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer',
            background:mode===m?'#0C447C':'#fff',color:mode===m?'#fff':'#555',boxShadow:'0 1px 3px rgba(0,0,0,0.1)'}}>
            {m === 'checkout' ? 'Check out' : 'Return item'}
          </button>
        ))}
      </div>
      {msg && <div style={{background:'#EAF3DE',border:'1px solid #97C459',borderRadius:'8px',padding:'10px 14px',color:'#27500A',fontSize:'13px',marginBottom:'14px'}}>{msg}</div>}
      {error && <div style={{background:'#FCEBEB',border:'1px solid #F09595',borderRadius:'8px',padding:'10px 14px',color:'#A32D2D',fontSize:'13px',marginBottom:'14px'}}>{error}</div>}

      {mode === 'checkout' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px'}}>
          <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'20px'}}>
            <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Find item</h2>
            <div style={{display:'flex',gap:'8px',marginBottom:'14px'}}>
              <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&searchItems()}
                placeholder="Search by name or SKU..." style={{flex:1,padding:'8px 12px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
              <button onClick={searchItems} style={{padding:'8px 14px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',cursor:'pointer'}}>Search</button>
            </div>
            {items.map((item,i) => (
              <div key={i} onClick={()=>setSelected(item)} style={{padding:'10px 12px',borderRadius:'8px',cursor:'pointer',marginBottom:'6px',
                background:selected?.id===item.id?'#E6F1FB':'#f8f8f8',border:selected?.id===item.id?'1.5px solid #185FA5':'1px solid #eee'}}>
                <div style={{fontWeight:'600',fontSize:'13px',color:'#222'}}>{item.name}</div>
                <div style={{fontSize:'11px',color:'#888'}}>{item.sku} · {item.quantity_available} available</div>
              </div>
            ))}
          </div>
          <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'20px'}}>
            <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Checkout details</h2>
            {selected && <div style={{background:'#E6F1FB',borderRadius:'8px',padding:'10px 12px',marginBottom:'14px',fontSize:'13px',color:'#0C447C',fontWeight:'500'}}>{selected.name}</div>}
            <div style={{marginBottom:'12px'}}>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Job site</label>
              <select value={form.site_id} onChange={e=>setForm({...form,site_id:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}}>
                <option value="">— No site —</option>
                {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div style={{marginBottom:'12px'}}>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Return date</label>
              <input type="date" value={form.due_at} onChange={e=>setForm({...form,due_at:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
            </div>
            <div style={{marginBottom:'12px'}}>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Quantity</label>
              <input type="number" min="1" value={form.quantity} onChange={e=>setForm({...form,quantity:parseInt(e.target.value)})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
            </div>
            <div style={{marginBottom:'16px'}}>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Notes (optional)</label>
              <textarea value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} rows="2" style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px',resize:'vertical'}} />
            </div>
            <button onClick={doCheckout} style={{width:'100%',padding:'10px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'14px',fontWeight:'600',cursor:'pointer'}}>
              Confirm checkout
            </button>
          </div>
        </div>
      )}

      {mode === 'return' && (
        <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'20px'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Your active checkouts</h2>
          <div style={{marginBottom:'14px',display:'flex',gap:'10px'}}>
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Condition</label>
              <select value={returnForm.condition_in} onChange={e=>setReturnForm({...returnForm,condition_in:e.target.value})} style={{padding:'7px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}}>
                <option value="good">Good</option>
                <option value="minor_wear">Minor wear</option>
                <option value="damaged">Damaged</option>
                <option value="lost">Lost</option>
              </select>
            </div>
            <div style={{flex:1}}>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Notes</label>
              <input value={returnForm.notes} onChange={e=>setReturnForm({...returnForm,notes:e.target.value})} placeholder="Optional notes..." style={{width:'100%',padding:'7px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
            </div>
          </div>
          {!activeCheckouts.length ? <p style={{color:'#888',fontSize:'13px'}}>No active checkouts</p>
            : activeCheckouts.map((co,i) => (
            <div key={i} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'10px 12px',borderRadius:'8px',background:'#f8f8f8',marginBottom:'8px',border:'1px solid #eee'}}>
              <div>
                <div style={{fontWeight:'600',fontSize:'13px',color:'#222'}}>{co.item_name} ({co.sku})</div>
                <div style={{fontSize:'11px',color:'#888'}}>Due: {new Date(co.due_at).toLocaleDateString()} · {co.site_name || 'No site'}</div>
              </div>
              <button onClick={()=>doReturn(co.id)} style={{padding:'7px 14px',background:'#3B6D11',color:'#fff',border:'none',borderRadius:'8px',fontSize:'12px',fontWeight:'600',cursor:'pointer'}}>
                Return
              </button>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
